import { STRIPE_IS_FETCHING, STRIPE_SET_ERROR } from 'reducers/actions-types';

/**
 * Make sure that the notifications with the highest priority come always as first
 * @param {array} notifications - notifications list
 * @returns {array} sorted array
 */
export default function stripeReducer(state = {
    error: null,
    isFetching: false,
}, { type, error, isFetching }) {
    switch (type) {
        case STRIPE_IS_FETCHING:
            return Object.assign({}, state, { isFetching });
        case STRIPE_SET_ERROR:
            return Object.assign({}, state, { error });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/stripe/index.js